<template>
  <div class="flex justify-center">
    <div
      class="p-2 rounded-2xl min-w-[15rem]"
      :class="{
        'cursor-not-allowed': !props.canSubmit,
        'cursor-pointer': props.canSubmit,
      }"
      :style="{
        backgroundColor: !!props.canSubmit ? `#${buttonColor}` : '#9ca3af',
      }"
      @click="nextStep()"
    >
      <p class="w-full text-center text-white text-3xl">
        {{ __(`co_reg_lander_002_step_${step}_submit`) }}
      </p>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  buttonColor: {
    type: String,
    required: true,
  },

  canSubmit: {
    type: Boolean,
    required: true,
  },

  step: {
    type: [Number, String],
    required: true,
  },
});

const emit = defineEmits(['submit']);

const nextStep = () => {
  if (!props.canSubmit) {
    return;
  }

  emit('submit');
};
</script>
